module.exports = __webpack_public_path__ + "img/cloudImg5.345631ef.png";